import { useMemo } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { AppProviders } from './AppProviders';
import { buildRoutes } from './router';
import type { AppServices } from './services';

/** Приложение: провайдеры и маршруты из реестра. Проверку сессии запускает main.tsx до первой отрисовки. */
export function App({ services }: { services: AppServices }) {
  const router = useMemo(() => createBrowserRouter(buildRoutes()), []);
  return (
    <AppProviders services={services}>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
